import { ShippingMethodsResponse } from "@jog/types"

import { JoggApiOption } from "./client"

export const getShippingMethodsBase =
    ({ execute }: Pick<JoggApiOption, "execute">) =>
    async (cartId: string): Promise<ShippingMethodsResponse> => {
        return execute({
            method: "GET",
            uri: `/ctp/shipping-methods/matching-cart?cartId=${cartId}&expand=zoneRates[*].zone`,
        })
    }
